export const onServiceWorkerUpdateReady = () => {
  const answer = window.confirm(
    `Esta Página ha sido actualizada ` + `¿Volver a cargar para mostrar la última versión?`
  );
  if (answer === true) {
    window.location.reload();
  }
};
